import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ListState } from '@usf/ngrx-list';
import { SortableSectionHeader } from '../../../shared/components/sortable-section/models/sortable-section.model';
import { ListsViewModel } from '../../model/lists-view.model';
import { ListsOverlayService } from '../../services/lists-overlay.service';
import { ListsService } from '../../services/lists.service';
import { ListTypes } from '@shared/constants/lists-constants';
import { MassDeleteDualPaneContainerComponent } from '../delete-list/mass-delete-dual-pane-container/mass-delete-dual-pane-container.component';
import { ListDownloadContainerComponent } from '../list-download-container/list-download-container.component';
import { ListPrintContainerComponent } from '../list-print-container/list-print-container.component';

@Component({
  template: '',
})
export class ListSectionBaseComponent {
  @Input() selectedHeader: string;
  @Input() sectionTitle: string;
  @Input() sectionHeaders: SortableSectionHeader[];
  @Input() lists: ListsViewModel[];
  @Input() recentlyPurchasedCount = 0;
  @Input() masterListItemsAreLoaded: boolean;
  @Input() massDeleteModalRef?: MassDeleteDualPaneContainerComponent;
  @Input() listDownloadModalRef?: ListDownloadContainerComponent;
  @Input() listPrintModalRef?: ListPrintContainerComponent;

  constructor(
    private translateService: TranslateService,
    protected listsService: ListsService,
    private listsOverlayService: ListsOverlayService,
  ) {}

  openListDetails(
    event: Event,
    shoppingListPath: string[],
    listName: string,
    aiListId?: string,
  ) {
    event.stopPropagation();
    if (!!aiListId && shoppingListPath[2].split('-')[0] === 'AI') {
      this.listsService.goToShoppingList(['lists', 'aiList', aiListId]);
    } else {
      const isRecentlyPurchasedList =
        listName.toLowerCase() === ListTypes.recentlyPurchased.toLowerCase() &&
        shoppingListPath[2].split('-')[0] !== 'SL' &&
        shoppingListPath[2].split('-')[0] !== 'ML' &&
        shoppingListPath[2].split('-')[0] !== 'OG';
      const isMasterList = shoppingListPath[2].split('-')[0] === 'ML';
      if (isRecentlyPurchasedList) {
        shoppingListPath = ['lists', 'recentlyPurchased'];
      } else if (isMasterList) {
        const mslKey = shoppingListPath[2];
        shoppingListPath = ['lists', 'masterList', mslKey];
      }
      this.listsService.goToShoppingList(shoppingListPath);
    }
  }

  async openListOptions(
    event: Event,
    shoppingListPath: string[],
    list: ListState,
    listName: string,
    listTypeId: string,
    downloadPrintFlag: boolean,
  ) {
    this.listsOverlayService.openListOptions(
      event,
      shoppingListPath,
      list,
      listName,
      listTypeId,
      false,
      downloadPrintFlag,
      false,
      this.massDeleteModalRef,
      this.listDownloadModalRef,
      this.listPrintModalRef,
    );
  }

  trackItem(index: any, item: any) {
    return item ? item?.listName : index;
  }
}
